var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2967 69.2118C83.0558 69.8602 81.776 70.4316 80.4647 70.9227C76.2908 72.483 71.8692 73.278 67.4126 73.2692C50.2086 73.2692 35.2223 61.4457 35.2223 46.2732C35.2443 44.2382 35.8095 42.2459 36.8596 40.5021C37.9097 38.7582 39.4066 37.3259 41.1957 36.3531C25.635 37.0069 21.6357 53.2074 21.6357 62.6989C21.6357 89.5351 46.3911 92.2558 51.7247 92.2558C54.6005 92.2558 58.9378 91.4203 61.541 90.5994L62.0173 90.4396C72.0345 86.9797 80.5742 80.2155 86.2309 71.2605C86.4042 70.9878 86.4815 70.6651 86.4507 70.3436C86.42 70.022 86.2828 69.7199 86.061 69.4849C85.8391 69.2499 85.5452 69.0955 85.2257 69.046C84.9062 68.9966 84.5794 69.0549 84.2967 69.2118Z",
    fill: "url(#paint0_linear_101_140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M84.2967 69.2118C83.0558 69.8602 81.776 70.4316 80.4647 70.9227C76.2908 72.483 71.8692 73.278 67.4126 73.2692C50.2086 73.2692 35.2223 61.4457 35.2223 46.2732C35.2443 44.2382 35.8095 42.2459 36.8596 40.5021C37.9097 38.7582 39.4066 37.3259 41.1957 36.3531C25.635 37.0069 21.6357 53.2074 21.6357 62.6989C21.6357 89.5351 46.3911 92.2558 51.7247 92.2558C54.6005 92.2558 58.9378 91.4203 61.541 90.5994L62.0173 90.4396C72.0345 86.9797 80.5742 80.2155 86.2309 71.2605C86.4042 70.9878 86.4815 70.6651 86.4507 70.3436C86.42 70.022 86.2828 69.7199 86.061 69.4849C85.8391 69.2499 85.5452 69.0955 85.2257 69.046C84.9062 68.9966 84.5794 69.0549 84.2967 69.2118Z",
    fill: "url(#paint1_radial_101_140)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7274 87.6935C35.4846 85.6826 32.6743 83.0477 30.4599 79.9419C27.9359 76.4871 26.1991 72.5224 25.3712 68.3259C24.5433 64.1294 24.6444 59.8027 25.6674 55.6494C26.6904 51.4961 28.6105 47.6167 31.2931 44.2833C33.9756 40.9499 37.3556 38.2432 41.1961 36.3531C42.3304 35.8191 44.2682 34.8529 46.8459 34.9001C48.662 34.9133 50.4503 35.3465 52.0707 36.1658C53.6912 36.9851 55.0997 38.1681 56.186 39.6222C57.6541 41.5808 58.4636 43.9536 58.4983 46.4003C58.4983 46.324 67.3912 17.4864 29.4128 17.4864C13.4522 17.4864 0.327337 32.619 0.327337 45.8954C0.264382 52.9185 1.76843 59.8673 4.73015 66.2369C9.57043 76.555 18.0348 84.7379 28.5158 89.2318C38.9969 93.7256 50.7648 94.2175 61.585 90.6139C57.7964 91.8073 53.7939 92.1656 49.8533 91.6639C45.9128 91.1622 42.1281 89.8125 38.7601 87.708L38.7274 87.6935Z",
    fill: "url(#paint2_linear_101_140)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M38.7274 87.6935C35.4846 85.6826 32.6743 83.0477 30.4599 79.9419C27.9359 76.4871 26.1991 72.5224 25.3712 68.3259C24.5433 64.1294 24.6444 59.8027 25.6674 55.6494C26.6904 51.4961 28.6105 47.6167 31.2931 44.2833C33.9756 40.9499 37.3556 38.2432 41.1961 36.3531C42.3304 35.8191 44.2682 34.8529 46.8459 34.9001C48.662 34.9133 50.4503 35.3465 52.0707 36.1658C53.6912 36.9851 55.0997 38.1681 56.186 39.6222C57.6541 41.5808 58.4636 43.9536 58.4983 46.4003C58.4983 46.324 67.3912 17.4864 29.4128 17.4864C13.4522 17.4864 0.327337 32.619 0.327337 45.8954C0.264382 52.9185 1.76843 59.8673 4.73015 66.2369C9.57043 76.555 18.0348 84.7379 28.5158 89.2318C38.9969 93.7256 50.7648 94.2175 61.585 90.6139C57.7964 91.8073 53.7939 92.1656 49.8533 91.6639C45.9128 91.1622 42.1281 89.8125 38.7601 87.708L38.7274 87.6935Z",
    fill: "url(#paint3_radial_101_140)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6695 54.0719C55.375 54.4533 54.4697 54.98 54.4697 56.1279C54.4697 57.0759 55.0878 57.9877 56.1857 58.7541C61.4139 62.3865 71.2702 61.907 71.2956 61.907C75.1696 61.8977 78.9701 60.8503 82.3009 58.874C85.661 56.9138 88.4497 54.1099 90.3904 50.7405C92.3311 47.3711 93.3563 43.5533 93.3643 39.6658C93.4588 31.5256 90.4557 26.1133 89.2414 23.716C81.5374 8.65965 64.9078 2.27622e-07 46.8239 2.27622e-07C34.5941 -0.00120798 22.8554 4.80748 14.1466 13.386C5.43787 21.9646 0.45909 33.6234 0.287109 45.8409C0.461622 32.5681 13.6664 21.8489 29.3726 21.8489C30.6451 21.8489 37.9019 21.9724 44.6424 25.5067C50.5832 28.6233 53.6953 32.3865 55.8585 36.117C58.1054 39.9928 58.5053 44.8892 58.5053 46.8398C58.5053 48.7904 57.5091 51.6818 55.6695 54.0719Z",
    fill: "url(#paint4_radial_101_140)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6695 54.0719C55.375 54.4533 54.4697 54.98 54.4697 56.1279C54.4697 57.0759 55.0878 57.9877 56.1857 58.7541C61.4139 62.3865 71.2702 61.907 71.2956 61.907C75.1696 61.8977 78.9701 60.8503 82.3009 58.874C85.661 56.9138 88.4497 54.1099 90.3904 50.7405C92.3311 47.3711 93.3563 43.5533 93.3643 39.6658C93.4588 31.5256 90.4557 26.1133 89.2414 23.716C81.5374 8.65965 64.9078 2.27622e-07 46.8239 2.27622e-07C34.5941 -0.00120798 22.8554 4.80748 14.1466 13.386C5.43787 21.9646 0.45909 33.6234 0.287109 45.8409C0.461622 32.5681 13.6664 21.8489 29.3726 21.8489C30.6451 21.8489 37.9019 21.9724 44.6424 25.5067C50.5832 28.6233 53.6953 32.3865 55.8585 36.117C58.1054 39.9928 58.5053 44.8892 58.5053 46.8398C58.5053 48.7904 57.5091 51.6818 55.6695 54.0719Z",
    fill: "url(#paint5_radial_101_140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_140",
    x1: 21.6357,
    y1: 64.3117,
    x2: 86.4745,
    y2: 64.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4472 64.8222) scale(34.6771 32.9136)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_140",
    x1: 55.8188,
    y1: 36.2114,
    x2: 15.3606,
    y2: 80.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_101_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9533 72.2878) rotate(-81.3767) scale(52.0992 42.1272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_101_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.68989 17.2092) rotate(92.2927) scale(73.5896 156.872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_101_140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.5698 28.117) rotate(73.7259) scale(35.3603 28.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.427f293cdc6f2dfb035dad512f730eab.svg";
export { ForwardRef as ReactComponent };